import { account } from "./es.account";
import { activity } from "./es.activity";
import { admin } from "./es.admin";
import { api } from "./es.api";
import { appBar } from "./es.app-bar";
import { builder } from "./es.builder";
import { bybcat } from "./es.bybcat";
import { challenges } from "./es.challenges";
import { demo } from "./es.demo";
import { dictionary } from "./es.dictionary";
import errors from "./es.errors";
import { leaderboard } from "./es.leaderboard";
import { members } from "./es.members";
import { metrics } from "./es.metrics";
import { navBar } from "./es.nav-bar";
import { notifications } from "./es.notifications";
import paths from "./es.path";
import { playlists } from "./es.playlists";
import { profile } from "./es.profile";
import { progress } from "./es.progress";
import { purchaseFlow } from "./es.purchase-flow";
import releaseNotes from "./es.release-notes";
import { roles } from "./es.roles";
import { sessionResults } from "./es.session-results";
import tags from "./es.tags";
import { teamManagement } from "./es.team-management";
import { metricTooltips } from "./es.tooltips";
import { welcome } from "./es.welcome";
import { mobileCommon } from "./mobile/es.mobile.common";
import { about } from "./settings/es.about";
import { help } from "./settings/es.help";
import { privacy } from "./settings/es.privacy";
import { security } from "./settings/es.security";
import { subscriptionManagement } from "./subscription-management";
import { career } from "./VR/es.vr.career";
import { coach } from "./VR/es.vr.coach";
import { common } from "./VR/es.vr.common";
import { guides } from "./VR/es.vr.guides";
import { header } from "./VR/es.vr.header";
import { vrHome } from "./VR/es.vr.home";
import { matchPlay } from "./VR/es.vr.match-play";
import { positionSelection } from "./VR/es.vr.position-selection";
import { practice } from "./VR/es.vr.practice";
import { settings } from "./VR/es.vr.settings";
import { trainingPlans } from "./VR/es.vr.training-plans";
import { byb360 } from "./web-portal/es.byb360";
import { portalHome } from "./web-portal/es.portal.home";
import { challengeEditor } from "./web-portal/super-admin/es.challenge-editor";

const es = {
  ...career,
  ...coach,
  ...common,
  ...header,
  ...vrHome,
  ...settings,
  ...progress,
  ...practice,
  ...trainingPlans,
  ...dictionary,
  ...sessionResults,
  ...guides,
  ...tags,
  ...challenges,
  ...errors,
  ...api,
  ...matchPlay,
  ...metrics,
  ...purchaseFlow,
  ...metricTooltips,
  ...roles,
  ...notifications,
  ...account,
  ...releaseNotes,
  ...challengeEditor,
  ...byb360,
  ...subscriptionManagement,
  ...admin,
  ...activity,
  ...appBar,
  ...security,
  ...bybcat,
  ...members,
  ...playlists,
  ...navBar,
  ...teamManagement,
  ...paths,
  ...leaderboard,
  ...profile,
  ...welcome,
  ...privacy,
  ...about,
  ...help,
  ...positionSelection,
  ...mobileCommon,
  ...demo,
  ...builder,
  ...portalHome,
};

export default es;
